var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',[_c('ListItem',{attrs:{"title":_vm.warehouse.name,"subtitle":_vm.$t('fields.name')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }